import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=2972adf8&lang=pug&"
import script from "./baseForm.vue?vue&type=script&lang=js&"
export * from "./baseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports